var WSEventType = /* @__PURE__ */ ((WSEventType2) => {
  WSEventType2["DEPOSIT_SUCCESS"] = "deposit-success";
  WSEventType2["BALANCE_CHANGED"] = "balance-changed";
  return WSEventType2;
})(WSEventType || {});
export {
  WSEventType
};
